export const STATUS_TYPES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVIEW_CANCEL: 'REVIEW_CANCEL',
  RETURNED: 'RETURNED',
  PENDING_APPROVAL: 'PENDING_APPROVAL'
};

export const REGISTRY_TYPE = {
  SERVICE: 'SERVICE',
  EVENTS: 'EVENTS',
  JOURNEY: 'JOURNEY',
  SOURCE: 'SOURCE'
};

export const REGISTRY_CRUD_STATUS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  CLONE: 'CLONE'
};
